//:: START :: logo marquee 
jQuery('.logo_marquee_slider').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear',
  arrows: false,
  dots: false,
  responsive: [
    {
      breakpoint: 1480,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});
//:: END :: logo marquee

//:: START :: image marquee scripts :: ==================
$('.image_marquee_slider').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear',
  arrows:false,
  dots:false,
  responsive: [
    {
      breakpoint: 1240,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

$('.product-thumbnail').slick({
  slidesToShow: 5.2,
  slidesToScroll: 1,
  asNavFor: '.product-media-slider',
  dots: false,
  arrows: true,
  infinite: false,
  focusOnSelect: true,
});

$('.c-r-card-col').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  infinite: true,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1240,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        dots: true,
        centerMode:true,
        slidesToScroll: 1
      }
    }
  ]
});

//:: END :: image marquee scripts :: ==================


//:: START :: Transformation Section scripts :: ==================

//setTimeout(function(){
  $('.transformation-block-slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows:false,
    dots:false,
    responsive: [
      {
        breakpoint: 1480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:true,
        }
      }
    ]
  });
//}, 1000);
//:: END :: Transformation Section scripts :: ==================

//:: START :: Product Faq :: ==================
document.addEventListener("DOMContentLoaded", function() {
  const accordions = document.querySelectorAll(".product-faq .accordion");

  accordions.forEach(accordion => {
    const head = accordion.querySelector(".accordion-head");
    const body = accordion.querySelector(".accordion-body");

    head.addEventListener("click", function() {
      // চেক করা হচ্ছে এটা অলরেডি একটিভ কিনা
      const isActive = accordion.classList.contains("active");

      // অন্য কোনো অ্যাকোর্ডিয়ন খোলা থাকলে তা বন্ধ করার জন্য (যদি চান একসাথে একটাই খুলবে)
      accordions.forEach(item => {
        item.classList.remove("active");
        item.querySelector(".accordion-body").style.maxHeight = null;
      });

      // বর্তমানেরটায় ক্লিক করলে যদি বন্ধ থাকে তবে ওপেন হবে
      if (!isActive) {
        accordion.classList.add("active");
        body.style.maxHeight = body.scrollHeight + "px";
      }
    });
  });
});
//:: END :: Product Faq :: ==================


//PRODUCT DETAILS PAGE FOR ON CHANGE RADIO TO SELECT DROPDOWN JS START 
jQuery(document).on("click",".product-single .checkbox-options .checkbox-label",function(e){
  var getDataval = jQuery(this).find('input[type="radio"]').attr('data-val');
  if(jQuery('.product-single').find('.new-atc-wrapper').find('.product-form__variants').length>0){
    jQuery('.product-single').find('.new-atc-wrapper').find('.product-form__variants option').removeAttr('selected');
    jQuery('.product-single').find('.new-atc-wrapper').find('.product-form__variants option[option-data-val="'+getDataval+'"]').attr('selected',true);
    // setTimeout(function(){
    //   jQuery('.product-single').find('.new-atc-wrapper').find('.product-form__variants').trigger("change");
    // },100);
    let element = document.getElementById('ProductSelect-product-template');
    element.dispatchEvent(new Event("change"));

  }
})




$("#go_to_top").click(function(){
    $("html, body").animate({scrollTop: 0}, "slow");
});


$(document).ready(function() {
  $(document).on("click", ".addToCart__custom", function(e) {
    var qty = $('.shopify-product-form').find('.js-qty__num').val();
    var vid = $('.shopify-product-form').find('select[name="id"]').val();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: vid,
        quantity: qty
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Added to cart:', data);
      // redirect to checkout
      window.location.href = '/cart';
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    });
  });
});


(function () {
  function updateBottomPrice() {
    // 1. Target main price element
    const topPriceEl = document.querySelector(
      ".price__container .price-item--sale, .price__container .price-item--regular"
    ) || document.querySelector('[id*="price-template"] .price-item');

    // 2. Target showProPrice container
    const targetPrices = document.querySelectorAll(".showProPrice");

    if (topPriceEl && targetPrices.length > 0) {
      const cleanPrice = topPriceEl.textContent.replace(/\s+/g, " ").trim();
      
      targetPrices.forEach((target) => {
        // Prevent unnecessary re-renders if text is already updated
        if (target.textContent !== cleanPrice) {
          target.textContent = cleanPrice;
        }
      });
    }
  }

  // Initial load sync
  document.addEventListener("DOMContentLoaded", updateBottomPrice);
  window.addEventListener("load", updateBottomPrice);

  // Variant change detection (Click & Change events)
  document.addEventListener("change", (e) => {
    if (e.target.closest("variant-selects, variant-radios, .product-form, fieldset, form")) {
      setTimeout(updateBottomPrice, 100);
      setTimeout(updateBottomPrice, 300);
    }
  });

  document.addEventListener("click", (e) => {
    if (e.target.closest("variant-selects, variant-radios, .product-form__input, fieldset, label, input[type='radio']")) {
      setTimeout(updateBottomPrice, 100);
      setTimeout(updateBottomPrice, 300);
    }
  });
})();